import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
//Imports firebase
import {auth} from "../../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
//Import contexts
import { AuthContext } from "../../contexts/AuthContext";
//Imports svg
import visible from '../../assets/icons/visible.svg';
import notVisible from '../../assets/icons/notVisible.svg';
//Import style
import './logIn.css';

function LogIn () {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const { setCurrentUser } = useContext(AuthContext);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'email') {
          setEmail(value);
        } else if (name === 'password') {
          setPassword(value);
        }
      };
      
      const handleSubmit = async (e) => {
        e.preventDefault(); // Evitar el comportamiento de envío de formulario predeterminado
        
        try {
          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          console.log('Usuario ha iniciado sesión:', userCredential.user);
          if(userCredential) {
            setCurrentUser(userCredential.user)
            setError(false);
            navigate('/');
          }
        } catch (error) {
          console.error('Error de inicio de sesión:', error);
          setError(true);
        }
      };

    return (
        <main className='login-main flex'>
            <section className='box-login flex'>
                <article className='login-title'>
                    <h1>Inicia Sesión</h1>
                    <p>Ingresa tus credenciales</p>
                </article>
                <form onSubmit={handleSubmit} className='form-login flex'>
                    <span className='input flex'>
                        <label htmlFor='email' className='label-email'>Correo electrónico</label>
                        <input type="email" id="email" name="email"  className='input-email' value={email} onChange={handleInputChange} placeholder='Ingresa correo electrónico' />
                    </span>
                    <span className='input flex'>
                        <label htmlFor="password" className='label-email'>Contraseña</label>
                        <span className='input-password flex'>
                            <input type={passwordVisible ? 'text' : 'password'} id="password" name="password" className='input-email password' value={password} onChange={handleInputChange} placeholder='Ingresa contraseña' />
                            <img src={passwordVisible ? notVisible : visible} alt='Icono para dar visibilidad a contraseña' className='icon-input'onClick={() => setPasswordVisible(!passwordVisible)}/>
                        </span>
                        {error && <p className='error-message'>Credenciales incorrectas, intentelo nuevamente.</p>}
                    </span>
                    <button type="submit" className='button-login'><h3>Log In</h3></button>
                    <Link to='/password-reset' className='link'><p>Recuperar contraseña</p></Link>
                </form>
            </section>
        </main>
    )
}

export default LogIn;